var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1262"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1262"
    },
    "bundlingPackage": "deal-plans-ui",
    "bundlingPackageVersion": "static-1.2229",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};